import { Box, Button, MenuItem, Select } from '@mui/material'
import { enqueueSnackbar } from 'notistack'
import { useState } from 'react'
import { ACH_EXPEDITED, ACH_NEXT_DAY, ACH_SAME_DAY, PAYMENT_OPTION_LABELS } from '../constants'
import { type PaymentOption, useReleasePaymentsMutation } from '../generated/graphql'
import { ConfirmDialog } from './ConfirmDialog'

interface ReleasePaymentButtonProps {
  selectedPaymentIds: number[]
  count: number
  onSuccess: () => void
}
export function ReleasePaymentButton({ selectedPaymentIds, count, onSuccess }: ReleasePaymentButtonProps) {
  const [paymentOption, setPaymentOption] = useState(ACH_EXPEDITED)
  const [confirmOpen, setConfirmOpen] = useState(false)
  const releasePaymentsMutation = useReleasePaymentsMutation({
    onSuccess: () => {
      enqueueSnackbar('Payments released successfully', { variant: 'success' })
      onSuccess()
    },
    onError: (error: Error) => {
      console.error(error)
      enqueueSnackbar(error?.message || 'Failed to release payments', {
        variant: 'error',
      })
    },
  })

  const handleReleasePayments = (paymentOption: string) => {
    releasePaymentsMutation.mutate({
      paymentIds: selectedPaymentIds.length > 0 ? selectedPaymentIds : undefined,
      paymentOption: paymentOption as PaymentOption,
    })
  }

  return (
    <Box sx={{ mb: 2, display: 'flex', gap: 2, alignItems: 'center' }}>
      <Button
        variant="contained"
        color="primary"
        disabled={releasePaymentsMutation.isPending || !count}
        onClick={() => setConfirmOpen(true)}
      >
        Release ({count}) UNDER_REVIEW Payments
      </Button>
      <Select
        value={paymentOption}
        onChange={e => setPaymentOption(e.target.value)}
        size="small"
        sx={{ minWidth: 250 }}
      >
        <MenuItem value={ACH_EXPEDITED}>{PAYMENT_OPTION_LABELS[ACH_EXPEDITED]}</MenuItem>
        <MenuItem value={ACH_NEXT_DAY}>{PAYMENT_OPTION_LABELS[ACH_NEXT_DAY]}</MenuItem>
        <MenuItem value={ACH_SAME_DAY}>{PAYMENT_OPTION_LABELS[ACH_SAME_DAY]}</MenuItem>
      </Select>

      <ConfirmDialog
        open={confirmOpen}
        onClose={() => setConfirmOpen(false)}
        confirmLabel="Release Payments"
        onConfirm={() => handleReleasePayments(paymentOption)}
      >
        You are about to release {count} selected payment(s).
        <Box component="span" sx={{ display: 'block', mt: 1.5 }}>
          They will be sent using <strong>{PAYMENT_OPTION_LABELS[paymentOption] ?? paymentOption}</strong>.
        </Box>
      </ConfirmDialog>
    </Box>
  )
}
